import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import paddingExample1 from './assets/images/padding-example1.png';
import paddingExample2 from './assets/images/padding-example2.png';
import paddingExample3 from './assets/images/padding-example3.png';


const CSSLesson32 = () => {
  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   div {
    padding-top: 50px;
    padding-right: 30px;
    padding-bottom: 50px;
    padding-left: 80px;
   }
  `
  );
  const code1 = (
  'text',
  `
   div {
    padding: 25px 50px 30px 25px;
   }
  `
  );
  const code2 = (
  'text',
  `
   div {
    padding: 25px 50px;
   }
  `
  );

  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>

          <h3><strong>CSS Padding</strong></h3>    
<p>The CSS padding properties are used to generate space around an element's content, inside of any defined borders.</p>
<p>With CSS, you have full control over the padding. There are properties for setting the padding for each side of an element (top, right, bottom, and left).</p><br/>

<div className="alert alert-secondary" role="alert">
<h3><strong>Padding - Individual Sides</strong></h3>
<ol class="list-group list-group-numbered mb-4">
  <li class="list-group-item">padding-top</li>
  <li class="list-group-item">padding-right</li>
  <li class="list-group-item">padding-left</li>
  <li class="list-group-item">padding-bottom</li>
</ol>
<CopyBlock
    language={"css"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

<div className="alert alert-secondary" role="alert">
<h3><strong>Using the Shorthand Property</strong></h3>
<p>In order to shorten the code, it is possible to specify all the padding properties in one property.</p>
<ol class="list-group list-group-numbered mb-4">
  <li class="list-group-item">padding: 25px 50px 75px 100px;</li>
  <li class="list-group-item">padding-top is <b>25px</b></li>
  <li class="list-group-item">padding-right is <b>50px</b></li>
  <li class="list-group-item">padding-bottom is <b>75px</b></li>
  <li class="list-group-item">padding-left is <b>100px</b></li>
</ol>
<CopyBlock
    language={"css"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

<div className="alert alert-secondary" role="alert">
<h3><strong>Padding With Two Values</strong></h3>
<p>If the <b class="text-danger">padding property</b> has two values, then top and bottom paddings will take the first value and right and left paddings will take the second value:</p>
<ol class="list-group list-group-numbered mb-4">
  <li class="list-group-item">padding: 25px 50px;</li>
  <li class="list-group-item">padding-top is <b>25px</b></li>
  <li class="list-group-item">padding-bottom is <b>25px</b></li>
  <li class="list-group-item">padding-rigth is <b>50px</b></li>
  <li class="list-group-item">padding-left is <b>50px</b></li>
</ol>
<CopyBlock
    language={"css"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    /> 

    </div>    
 

                          </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson32;
